// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2JfUz","requiredAsterisk":"Info_requiredAsterisk__98Cqx"};